import { savedOrderListFilterStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListFilter";
import { savedOrderListTableStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

savedOrderListFilterStyles.container = {
    css: css`
        padding-bottom: 15px;
        > div[class^="GridOffset"] {
            max-width: 100%;
            margin: 0;
        }
    `,
};

savedOrderListFilterStyles.headingGridItem = {
    width: 12,
    css: css`
        padding: 15px 0;
    `,
};

savedOrderListFilterStyles.buttonsItem = {
    width: [6, 6, 4, 4, 4],
    css: css`
        justify-content: flex-end;
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    padding: 15px 0 0 0;
                    justify-content: flex-start;
                `,
                css`
                    padding: 15px 0 0 0;
                    justify-content: flex-start;
                `,
                css`
                    padding: 15px 0 0 0;
                    justify-content: flex-start;
                `,
                css`
                    padding-right: 0;
                    justify-content: flex-end;
                `,
                css`
                    padding-right: 0;
                    justify-content: flex-end;
                `,
            ]);
        }}
    `,
};

savedOrderListFilterStyles.clearFiltersButton = {
    variant: "secondary",
    css: css`
        margin-right: 0;
        margin-top: 10px;
    `,
};

savedOrderListFilterStyles.fromGridItem = {
    width: 6,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding-left: 0;
                    `,
                    null,
                    null,
                ],
                "max",
            )}
        > div {
            width: 100%;
        }
    `,
};
savedOrderListFilterStyles.toGridItem = {
    width: 6,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding-right: 0;
                    `,
                    null,
                    null,
                ],
                "max",
            )}
        > div {
            width: 100%;
        }
    `,
};

savedOrderListFilterStyles.toDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
            position: relative;
            label {
                position: absolute;
                z-index: 1;
                left: 20px;
                background: #fff;
                width: auto;
                top: 3px;
                line-height: 12px;
                min-height: auto;
            }
        `,
    },
};

savedOrderListFilterStyles.orderTotalAmountTextField = {
    cssOverrides: {
        formInputWrapper: css`
            margin-top: 10px;
        `,
    },
};

savedOrderListFilterStyles.fromDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
            position: relative;
            label {
                position: absolute;
                z-index: 1;
                left: 20px;
                background: #fff;
                width: auto;
                top: 3px;
                line-height: 12px;
                min-height: auto;
            }
        `,
    },
};

savedOrderListFilterStyles.datesGridItem = {
    css: css`
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    padding: 15px 0 0 0;
                `,
                css`
                    padding: 15px 0 0 0;
                `,
                css`
                    padding-right: 0;
                `,
                null,
                null,
            ]);
        }}
    `,
    width: [12, 12, 6, 4, 4],
};

savedOrderListFilterStyles.datesContainer = {
    gap: 10,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        > div[class^="GridOffset"] {
                            width: 100%;
                            margin: 0;
                        }
                    `,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};
savedOrderListFilterStyles.orderTotalGridItem = {
    css: css`
        padding: 15px 0 0 0;
    `,
    width: [12, 12, 6, 4, 4],
};

savedOrderListTableStyles.container = {
    css: css`
        overflow: auto;
        margin-top: 5px;
        margin-bottom: 20px;
    `,
};

savedOrderListFilterStyles.orderTotalFieldset = {
    css: css`
        border: none;
        margin: 0;
        padding: 0;
        width: 100%;
        div[class^="GridOffset"] {
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin: 0;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        }
    `,
};

savedOrderListFilterStyles.orderTotalOperatorGridItem = {
    width: 6,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding-left: 0;
                    `,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

savedOrderListFilterStyles.orderTotalAmountGridItem = {
    width: 6,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding-right: 0;
                    `,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};
